var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseSmall16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.778 4.707a1 1 0 0 0-1.414 0l-2.111 2.11-2.06-2.06a1 1 0 0 0-1.415 1.414l2.06 2.061-2.131 2.132a1 1 0 1 0 1.414 1.414l2.132-2.132 2.182 2.182a1 1 0 0 0 1.414-1.414L9.667 8.232l2.111-2.11a1 1 0 0 0 0-1.415"
})));
export default SvgIcCloseSmall16;